import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { FormatCallProvidersPipeModule } from 'src/app/pipes/format-call-providers/format-providers-numbers-pipe.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { FormatSecondsPipeModule } from 'src/app/pipes/format-seconds/format-seconds-pipe.module';
import { CallCostsDialogComponent } from './call-costs-dialog.component';

@NgModule({
   declarations: [CallCostsDialogComponent],
   imports: [
      CommonModule,
      MatDialogModule,
      MatButtonModule,
      FormatPhoneNumbersPipeModule,
      FormatSecondsPipeModule,
      LcsResponsiveTableModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      FormatCallProvidersPipeModule,
   ],
   providers: [CallCostsDialogComponent],
})
export class CallCostsDialogModule {}
